import Joi from '@hapi/joi'

export const EmployeeBiometricSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    registrationNumber: Joi.string().allow(null, "").alphanum().max(20).label("Registration Number").messages({
        
        "string.pattern.base": `Please enter valid Registration Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    NIC: Joi.string().allow(null, "").alphanum().max(50).label("NIC").messages({
        
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
}

export const EmployeeListingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    employeeCode: Joi.string().max(20).required().regex(/^(?!\s*$).+/).label("Employee Code").messages({
        "string.pattern.base": `Please enter valid Employee Code`,
        "string.max": `Please enter {#limit} characters.`
    }),
    NIC: Joi.string().max(50).required().regex(/^(?!\s*$).+/).label("NIC").messages({
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
}

export const EmployeeSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Select Collectionpoint.`,
        "any.required": `Collectionpoint required`
    }),    
    employeeTypeID: Joi.number().invalid(0).required().label("Employee Category").messages({
        "any.invalid": `Select Employee Category.`,
        "any.required": `Employee Category required`
    }),
    employeeCategoryID: Joi.number().invalid(0).required().label("Employee Type").messages({
        "any.invalid": `Select Employee Type.`,
        "any.required": `Employee Type required`
    }),
    employeeCode:  Joi.string().allow("", null),
    title: Joi.number().invalid(0).required().required().label("Title").messages({
        "any.invalid": `Title required`,
        "any.invalid": `Please enter valid Title`
    }),
    firstName: Joi.string().max(100).required().label("First Name").messages({
        "string.empty": `First Name required`,
        "string.pattern.base": `Please enter valid First Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    secondName: Joi.string().max(100).allow("", null).label("Second Name").messages({
        "string.pattern.base": `Please enter valid Second Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    lastName: Joi.string().max(100).allow("", null).label("Last Name").messages({
        "string.pattern.base": `Please enter valid Last Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    gender: Joi.number().invalid(0).required().label("Gender").messages({
        "any.invalid": `Gender required`,
        "any.required": `Please enter valid Gender`,
    }),
    nic: Joi.string().alphanum().max(50).required().label("NIC").messages({
        "string.empty": `NIC required`,
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
    epfNo: Joi.string().max(50).allow("", null).label("EPF No").messages({
        "string.pattern.base": `Please enter valid EPF No`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address1:  Joi.string().max(100).allow("", null).label("Address1").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address2:  Joi.string().max(100).allow("", null).label("Address2").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address3:  Joi.string().max(100).allow("", null).label("Address3").messages({
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    city: Joi.string().alphanum().max(50).allow("", null).label("City").messages({
        "string.pattern.base": `Please enter valid City`,
        "string.max": `Please enter {#limit} characters.`
    }),
    countryCode: Joi.number().invalid(0).required().label("Country").messages({
        "any.invalid": `Country required`,
        "any.required": `Please enter valid Country`
    }),
    homePhoneNo: Joi.number().allow("", null).label("Home Phone Number").messages({
        "string.pattern.base": `Please enter valid Home Phone Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    officePhoneNo: Joi.number().allow("", null).label("Office Phone Number").messages({
        "string.pattern.base": `Please enter valid Home Office Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    dateOfBirth: Joi.string().isoDate().required().label("Date of birth"),
    mobileNo: Joi.number().allow("", null).label("Mobile Number").messages({
        "string.pattern.base": `Please enter valid Mobile Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    email:  Joi.string().allow("", null).label("Email").regex(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/).messages({
        "string.pattern.base": `"Invalid Email`,
    }),
    question: Joi.string().max(25).allow("", null).label("Question").messages({
        "string.pattern.base": `Please enter valid Question`,
        "string.max": `Please enter {#limit} characters.`
    }),
    answer: Joi.string().max(25).allow("", null).label("Answer").messages({
        "string.pattern.base": `Please enter valid Answer`,
        "string.max": `Please enter {#limit} characters.`
    }),
    registrationNumber:  Joi.string().alphanum().max(10).required().label("Registration Number").messages({
        "string.empty": `Registration Number required`,
        "string.pattern.base": `Please enter valid Registration Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    nameToBePrinted:  Joi.string().max(20).required().label("Name To Be Printed").messages({
        "string.empty": `Name To Be Printed required`,
        "string.pattern.base": `Please enter valid Name To Be Printed`,
        "string.max": `Please enter {#limit} characters.`
    }),
    isSupplementary: Joi.boolean().label("Active"),
    employeeSubCategoryID:  Joi.number().invalid(0).required().label("Employee Subcategory").messages({
        "any.invalid": `Select Employee Subcategory.`,
        "any.required": `Employee Subcategory required`
    }),
    designationID:Joi.number().invalid(0).required().label("Designation").messages({
        "any.invalid": `Select Designation.`,
        "any.required": `Designation required`
    }),
    maritalStatusID:Joi.number().invalid(0).required().label("Marital Status").messages({
        "any.invalid": `Select Marital Status.`,
        "any.required": `Marital Status required`
    }),
    raceID: Joi.number().invalid(0).required().label("Employee Race").messages({
        "any.invalid": `Select Employee Race.`,
        "any.required": `Employee Race required`
    }),
    religionID: Joi.number().invalid(0).required().label("Employee Religion").messages({
        "any.invalid": `Select Employee Religion.`,
        "any.required": `Employee Religion required`
    }),
}